<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" @click="cerrar"><i
                        class="fas fa-times"></i></b-button>
            </div>
            <b-container fluid>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            {{ datos_certificacion.tipo_de_respuesta }}
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                            <thead>
                                <tr>
                                    <th>
                                        Clave
                                    </th>
                                    <th>
                                        Info
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        Código
                                    </td>
                                    <td>
                                        {{ datos_certificacion.codigo }}
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td>
                                        Autorizacion
                                    </td>
                                    <td>
                                        {{ datos_certificacion.datos_cert.Autorizacion }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Serie
                                    </td>
                                    <td>
                                        {{ datos_certificacion.datos_cert.Serie }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Número
                                    </td>
                                    <td>
                                        {{ datos_certificacion.datos_cert.Numero }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Fecha
                                    </td>
                                    <td>
                                        {{ datos_certificacion.datos_cert.Fecha_de_certificacion }}
                                    </td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ModalFacutra',
        props: ['datos_certificacion'],
        data() {
            return {

            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            }
        },
    }
</script>

<style></style>